import { render, staticRenderFns } from "./productMapping.vue?vue&type=template&id=0a38b201&scoped=true&"
import script from "./productMapping.vue?vue&type=script&lang=js&"
export * from "./productMapping.vue?vue&type=script&lang=js&"
import style0 from "./productMapping.vue?vue&type=style&index=0&id=0a38b201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38b201",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a38b201')) {
      api.createRecord('0a38b201', component.options)
    } else {
      api.reload('0a38b201', component.options)
    }
    module.hot.accept("./productMapping.vue?vue&type=template&id=0a38b201&scoped=true&", function () {
      api.rerender('0a38b201', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/productMapping.vue"
export default component.exports